<div class="grid-x">
  @if (!canEdit) {
    <div class="cell large-6 medium-6 small-6">
      <div class="full-width text-align-center">
        <span class="bold underline">Dates</span>
      </div>
      <div class="grid-x">
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Permit Issued:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{well?.constructionPermit?.dateApproved | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Permit Expired:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{well?.constructionPermit?.dateExpired | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Permit Revoked:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{well?.dateOfRevocation | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Spud Date:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{well?.dateWellDrillingStarted | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Date Total Depth Reached:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{well?.dateTotalDepthReached | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Date of First Production:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{well?.production?.dateOfFirstProduction | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Plug Date:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{well?.plugging?.datePluggedAndAbandoned | date: 'longDate':'+0000' }}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Re-Plug Date:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{well?.plugging?.dateOfPlugBack | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Final Restoration Date:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ finalRestorationDate | date: 'longDate':'+0000' }}
        </div>
      </div>
    </div>
    <div class="cell large-6 medium-6 small-6  text-align-center">
      <div class="full-width text-align-center">
        <span class="bold underline">Received Dates</span>
      </div>
      <div class="grid-x">
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">As Drilled Plat Preliminary:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.asDrilledPlatPreliminaryDate | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">As Drilled Plat Final:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.asDrilledPlatFinalDate | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Deviation Survey:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.boreholeDeviationSurveyDate | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Revised Unit:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.revisedUnitDate | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Form 8 Preliminary:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.form8PreliminaryReceivedDate | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Form 8 Final:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.form8FinalReceivedDate| date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Logs:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.logsReceivedDate| date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Form 8A:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.form8ASurfaceHoleReceivedDate| date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Form 8B:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.form8BWellStimulationReceivedDate| date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Cement Tickets:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.cementTicketReceivedDate | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Cement Job Logs:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.cementLogReceivedDate  | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">P-R Graph:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.prGraphReceivedDate   | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Stimulation Invoice:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.stimInvoiceReceivedDate    | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Stimulation Record:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.stimRecordReceivedDate     | date: 'longDate':'+0000'}}
        </div>
        <div class="cell large-7 medium-7 small-6 text-align-right">
          <span class="bold padding-right">Stimulation Log:</span>
        </div>
        <div class="cell large-5 medium-5 small-6 text-align-left">
          {{ well?.wellComplianceData?.stimLogReceivedDate     | date: 'longDate':'+0000'}}
        </div>
      </div>
    </div>
  } @else {
    <div class="small-12">
      <h3 class="h4 no-margin-bottom margin-top bold">Compliance Dates</h3>
      <span class="shrink-font">
        An <svg-icon class="tiny" icon="icon-notepad"></svg-icon> icon indicates a field is editable.
        An <svg-icon class="tiny" icon="icon-notepad-alert"></svg-icon> icon indicates a field is editable and has unsaved changes.
        Click on either icon to edit the field.
      </span>
    </div>
    <div class="grid-x">
      <!-- Dates Column -->
      <div class="cell large-6 medium-6 small-6">
        <div class="full-width text-align-center">
          <span class="bold underline">Dates</span>
        </div>
        <div class="grid-x">
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Permit Issued:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('permitIssued')?.get('permitIssued')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('permitIssued')" [icon]="getEditIcon('permitIssued')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Permit Expired:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('permitExpired')?.get('permitExpired')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('permitExpired')" [icon]="getEditIcon('permitExpired')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Permit Revoked:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('permitRevoked')?.get('permitRevoked')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('permitRevoked')" [icon]="getEditIcon('permitRevoked')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Spud Date:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('spudDate')?.get('spudDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('spudDate')" [icon]="getEditIcon('spudDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Date Total Depth Reached:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('dateTotalDepthReached')?.get('dateTotalDepthReached')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('dateTotalDepthReached')" [icon]="getEditIcon('dateTotalDepthReached')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Date of First Production:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('dateOfFirstProduction')?.get('dateOfFirstProduction')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('dateOfFirstProduction')" [icon]="getEditIcon('dateOfFirstProduction')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Plug Date:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('plugDate')?.get('plugDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('plugDate')" [icon]="getEditIcon('plugDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Re-Plug Date:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('replugDate')?.get('replugDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('replugDate')" [icon]="getEditIcon('replugDate')"></svg-icon>
          </div>
          <!-- This field is only relevant when the well disposition is Final Restoration -->
          @if (isInFinalRestoration) {
            <div class="cell large-7 medium-7 small-6 text-align-right">
              <span class="bold padding-right">Final Restoration Date:</span>
            </div>
            <div class="cell large-5 medium-5 small-6 text-align-left">
              {{ editorForm?.get('finalRestorationDate')?.get('finalRestorationDate')?.value | date: 'longDate':'+0000' }}
              <svg-icon class="tiny icon-button" (click)="openEditor('finalRestorationDate')" [icon]="getEditIcon('finalRestorationDate')"></svg-icon>
            </div>
          }
        </div>
      </div>
      <div class="cell large-6 medium-6 small-6 text-align-center">
        <div class="full-width text-align-center">
          <span class="bold underline">Received Dates</span>
        </div>
        <div class="grid-x">
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">As Drilled Plat Preliminary:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('asDrilledPlatPreliminaryDate')?.get('asDrilledPlatPreliminaryDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('asDrilledPlatPreliminaryDate')" [icon]="getEditIcon('asDrilledPlatPreliminaryDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">As Drilled Plat Final:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('asDrilledPlatFinalDate')?.get('asDrilledPlatFinalDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('asDrilledPlatFinalDate')" [icon]="getEditIcon('asDrilledPlatFinalDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Deviation Survey:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('boreholeDeviationSurveyDate')?.get('boreholeDeviationSurveyDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('boreholeDeviationSurveyDate')" [icon]="getEditIcon('boreholeDeviationSurveyDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Revised Unit:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('revisedUnitDate')?.get('revisedUnitDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('revisedUnitDate')" [icon]="getEditIcon('revisedUnitDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Form 8 Preliminary:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('form8PreliminaryReceivedDate')?.get('form8PreliminaryReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('form8PreliminaryReceivedDate')" [icon]="getEditIcon('form8PreliminaryReceivedDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Form 8 Final:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('form8FinalReceivedDate')?.get('form8FinalReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('form8FinalReceivedDate')" [icon]="getEditIcon('form8FinalReceivedDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Logs:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('logsReceivedDate')?.get('logsReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('logsReceivedDate')" [icon]="getEditIcon('logsReceivedDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Form 8A:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('form8ASurfaceHoleReceivedDate')?.get('form8ASurfaceHoleReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('form8ASurfaceHoleReceivedDate')" [icon]="getEditIcon('form8ASurfaceHoleReceivedDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Form 8B:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('form8BWellStimulationReceivedDate')?.get('form8BWellStimulationReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('form8BWellStimulationReceivedDate')" [icon]="getEditIcon('form8BWellStimulationReceivedDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Cement Tickets:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('cementTicketReceivedDate')?.get('cementTicketReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('cementTicketReceivedDate')" [icon]="getEditIcon('cementTicketReceivedDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Cement Job Logs:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('cementLogReceivedDate')?.get('cementLogReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('cementLogReceivedDate')" [icon]="getEditIcon('cementLogReceivedDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">P-R Graph:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('prGraphReceivedDate')?.get('prGraphReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('prGraphReceivedDate')" [icon]="getEditIcon('prGraphReceivedDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Stimulation Invoice:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('stimInvoiceReceivedDate')?.get('stimInvoiceReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('stimInvoiceReceivedDate')" [icon]="getEditIcon('stimInvoiceReceivedDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Stimulation Record:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('stimRecordReceivedDate')?.get('stimRecordReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('stimRecordReceivedDate')" [icon]="getEditIcon('stimRecordReceivedDate')"></svg-icon>
          </div>
          <div class="cell large-7 medium-7 small-6 text-align-right">
            <span class="bold padding-right">Stimulation Log:</span>
          </div>
          <div class="cell large-5 medium-5 small-6 text-align-left">
            {{ editorForm?.get('stimLogReceivedDate')?.get('stimLogReceivedDate')?.value | date: 'longDate':'+0000' }}
            <svg-icon class="tiny icon-button" (click)="openEditor('stimLogReceivedDate')" [icon]="getEditIcon('stimLogReceivedDate')"></svg-icon>
          </div>
        </div>
      </div>
    </div>
  }
</div>


